import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Loading } from 'e4shared';
import BlobImage from 'components/blobImage';
import { e4Format } from 'helpers/dates';

export const UnreviewedModal = ({ data, st, history }) => {
    if (!data) return <Loading />;
    return (
        <div>
            {data.map(d => {
                return (
                    <div key={d.profile_Id} className="flex flex-center mb10">
                        <BlobImage
                            height="30"
                            className="img-square mr10"
                            folder="avatar"
                            initials={d.initials}
                            src={d.avatar}
                        />
                        <div className="flex-grow">
                            <div>
                                <span className="mr10">
                                    <Link to={`/develop/reviews/${d.id || d.profile_Id}`}>{d.full_Name}</Link>
                                </span>
                                <span className="mr10">
                                    {st('Unreviewed/StartDate')}: {e4Format(d.start_Date)}
                                </span>
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default withRouter(UnreviewedModal);
